export const FETCH_ALL_DOCTOR = 'fetch_all_doctor';
export const FETCH_ALL_DOCTOR_SUCCESS = 'fetch_all_doctor_success';
export const EDIT_DOCTOR = 'edit_doctor';
export const DELETE_DOCTOR = 'delete_doctor';
export const CREATE_DOCTOR = 'create_doctor';
export const CREATE_DOCTOR_SUCCESS = 'create_doctor_success';
export const UPDATE_DOCTOR_SUCCESS = 'update_doctor_success';
export const UPDATE_DOCTOR = 'update_doctor';
export const DELETE_DOCTOR_SUCCESS = 'delete_doctor_success';
export const SET_DOCTOR = 'set_doctor';
export const INIT_DOCTOR = 'init_doctor';
export const SET_DOCTOR_MULTI = 'set_doctor_multi';
export const SET_ROLE = 'set_role';
export const DOCTOR_POPUP_STATUS_CHANGE = 'doctor_popup_status_change';
export const DOCTOR_SEND_SMS = 'doctor_send_sms';
export const DOCTOR_SMS_RESULT = 'doctor_sms_result';
export const FETCH_ALL_DOCTOR_NAMES = 'fetch_all_doctor_names';
export const FETCH_ALL_DOCTOR_NAMES_SUCCESS = 'fetch_all_doctor_names_success';
export const COPY_DOCTOR_TO_GEN2 = "copy_doctor_to_gen2";
export const COPY_DOCTOR_TO_GEN2_STATUS = "copy_doctor_to_gen2_status";
export const COPY_DOCTOR_TO_GEN2_STATUS_CLEAR = "copy_doctor_to_gen2_status_clear";
export const CREATE_DOCTOR_ONBOARD_URL = "create_doctor_onboard_url";
export const COPY_DOCTOR_ONBOARD_URL = "COPY_DOCTOR_ONBOARD_URL";
export const CLEAR_DOCTOR_ONBOARD_URL = "clear_doctor_onboard_url";
export const FILTER_DOCTORS = "filter_doctors";
export const FILTER_DOCTORS_SUCCESS = "filter_doctors_success";
export const UPDATE_EXCLUDE_DOCTORS_FOR_DOCTOR_REPORTS = "update_exclude_doctors_for_doctor_reports";
export const UPDATE_DOCTOR_STATUS = "update_doctor_status";
export const UPDATE_DOCTOR_STATUS_SUCCESS = "update_doctor_status_success";
export const UPDATE_DOCTOR_ACCOUNT_STATUS = "update_doctor_account_status";
